import React from 'react';
import { Area, AreaChart, Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from 'recharts';

const Dashboard = () => {
    const data = [
        {
            "month": "Mar",
            "investment": 100000,
            "sell": 20141,
            "revenue": 104010
        },
        {
            "month": "Apr",
            "investment": 200000,
            "sell": 44123,
            "revenue": 245500
        },
        {
            "month": "May",
            "investment": 500000,
            "sell": 70726,
            "revenue": 670010
        },
        {
            "month": "Jun",
            "investment": 500000,
            "sell": 102990,
            "revenue": 404056
        },
        {
            "month": "Jul",
            "investment": 600000,
            "sell": 60134,
            "revenue": 509000
        },
        {
            "month": "Aug",
            "investment": 700000,
            "sell": 67000,
            "revenue": 610000
        }
    ]
    return (

        <div className='container mt-5'>
            <h2 style={{color:'#2a5568'}} className="mb-5">Sells with Revenue</h2>
            <div className="row">
                <div className="col-12 col-md-6">
                    <BarChart width={500} height={250} data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" />
                        <YAxis dataKey={'investment'} />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="revenue" fill="#8884d8" />
                        <Bar dataKey="sell" fill="#82ca9d" />
                    </BarChart>
                </div>
                <div className="col-12 col-md-6">
                    <AreaChart width={500} height={250} data={data}
                        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                        <defs>
                            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                                <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
                            </linearGradient>
                            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                                <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <XAxis dataKey="month" />
                        <YAxis dataKey={"investment"} />
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip />
                        <Area type="monotone" dataKey="sell" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
                        <Area type="monotone" dataKey="revenue" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
                    </AreaChart>
                </div>
            </div>
        </div>
    );

};

export default Dashboard;